module.exports = __webpack_public_path__ + "media/tape-nav/commerce-campaign-icon-da9df2a3.svg";